import {
  isHeaderCustomField,
  isHeaderDate,
  isHeaderItemField,
} from '@/components/loop-visualizations/layout/header-menu/utils';
import type { IDateHeaderSelector, IPropertySelectorByID } from '@/lib/api/types/roadmapping';

export class MissingItemTypeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MissingItemTypeError';
  }
}

export const headerToPropertySelector = (header?: string | null): IPropertySelectorByID | null => {
  if (!header) {
    return null;
  }
  // Use the selector provided by Swimlane for parent items.
  if (header === 'parentItem') {
    return {
      type: 'ParentItemSelector',
    };
  } else if (header === 'createdBy') {
    return {
      type: 'createdBy',
    };
  } else if (isHeaderCustomField(header) || isHeaderItemField(header)) {
    return {
      type: 'CustomPropertySelectorByID',
      customPropertyID: header,
    };
  } else if (isHeaderDate(header)) {
    return {
      type: 'DateSelector',
      header,
    } as IDateHeaderSelector;
  }

  throw new Error(`Unknown header type: ${header}`);
};
